module Meevo.Plugins.Register {
    "use strict";

    export class ManualCreditCardPaymentController {
        static $inject = ["$mdDialog", "meevo.components.modal.ModalService",
            "paymentRequest", "paymentTypes"];
        cardEntryTypeExclusionList = [Model.CardEntryTypeEnum.Unknown];
        creditCardPaymentTypes;
        paymentType;

        constructor(private $mdDialog: angular.material.IDialogService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected paymentRequest, paymentTypes) {
            this.creditCardPaymentTypes = _(paymentTypes).filter(paymentType=> {
                return paymentType.paymentCategory == Model.PaymentCategoryEnum.CreditDebit || paymentType.paymentCategory == Model.PaymentCategoryEnum.Debit;
            });
        }
        cancel() {
            this.$mdDialog.hide(false);
        }

        save() {
            this.$mdDialog.hide(true);
        }
    }

    angular.module("meevo.plugins.register").controller("meevo.plugins.register.ManualCreditCardPaymentController", ManualCreditCardPaymentController);
}